import type { Customer } from './types'

let _customers: Customer[] = []

export function setCustomers(customers: Customer[]) {
  _customers = customers
}

export function customerById(customers: Customer[] | undefined, id: string): Customer | undefined {
  return (customers ?? _customers).find((c) => c.id === id)
}
